import { render, staticRenderFns } from "./FarmPredictionsWidget.vue?vue&type=template&id=58a445cc&scoped=true"
import script from "./FarmPredictionsWidget.vue?vue&type=script&lang=js"
export * from "./FarmPredictionsWidget.vue?vue&type=script&lang=js"
import style0 from "./FarmPredictionsWidget.vue?vue&type=style&index=0&id=58a445cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a445cc",
  null
  
)

export default component.exports